<template>
  <div class="wrapper">
    <div class="header">
      <a-alert
        v-if="type == 'edit'"
        :message="$t('page_control_tips')"
        type="info"
        show-icon
        style="width:520px"
      />
      <a-button v-else type="primary" @click="openEdit">{{ $t('page_control_edit') }}</a-button>
    </div>
    <div
      class="container-wrapper"
      :style="type == 'edit' ? '  height: calc(100% - 320px)' : 'height:calc(100% - 50px)'"
    >
      <div
        ref="container"
        class="container"
        :style="type !== 'edit' ? 'height:auto' : ''"
        @dragover="overContainer"
        @drop="endDrag"
      >
        <template v-if="!loading">
          <div
            v-for="(item, index) in items"
            :key="item.id + item.cardLocal"
            class="item-card-wrapper"
            :style="{
              ...getPosition(JSON.parse(item.cardLocal), unit),
              ...getCursor
            }"
            :draggable="type === 'edit'"
            @dragstart="(e) => startDrag(item, true)"
            @dragend="hidePlaceHolder"
          >
            <div :key="index" class="item-card-content">
              <component
                :is="showComponent(item)"
                :id="item.id"
                :item="item"
                :type="type"
                :unit="unit"
                @saveNameEdit="(value, item) => saveNameEdit(value, item)"
                @deleteItem="(item) => deleteItem(item)"
                class="comp"
              ></component>
            </div>
          </div>
        </template>

        <div class="placeholder" :style="plStyle">
          <div>
            <div class="placeholder-header">
              <span>{{ $t('page_control_card_name') }}</span>
              <a-icon type="delete" theme="twoTone" two-tone-color="red" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="type == 'edit'">
      <div class="footer-buttons">
        <a-button type="primary" style="margin-right:10px" @click="saveEdit">{{
          $t('save')
        }}</a-button>
        <a-button type="danger" @click="cancelEdit">{{ $t('cancel') }}</a-button>
      </div>
      <div class="cards">
        <div class="card" v-for="card in cards" :key="card.id">
          <img
            :src="card.avatar"
            :draggable="true"
            @dragstart="(e) => startDrag(card, false)"
            @dragend="hidePlaceHolder"
            :style="getCursor"
          />
          <div>{{ card.displayName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutPie from './cards/DoughnutPie'
import UnfinishedPlanTable from './cards/UnfinishedPlanTable'
import UtilizationChart from './cards/UtilizationChart'
import DeviceStatusTable from './cards/DeviceStatusTable'
import DeviceAlarmTable from './cards/DeviceAlarmTable'
import EmployeePerformanceTable from './cards/EmployeePerformanceTable'
import WorkRecord from './cards/WorkRecord'
import PendingWork from './cards/PendingWork'
import RegionalCompletion from './cards/RegionalCompletion'
import TotalRegions from './cards/TotalRegions'
import ThresholdRateTable from './cards/ThresholdRateTable.vue'
import ScreeningCustomersTable from './cards/ScreeningCustomersTable.vue'
import DisabledCard from './cards/DisabledCard.vue'
import MapView from './cards/MapView.vue'
import GatewayStatueRecordCard from './cards/GatewayStatueRecordCard';
import GatewayOverviewCard from './cards/GatewayOverviewCard'
import RepeatCustomDevice from './cards/RepeatCustomDevice'
import InactiveDevice from './cards/InactiveDevice.vue'

import {
  TenantSettingServiceProxy,
  AppCardServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import Drag, { getPosition } from './utils/drag'
import configs from './utils/options'
import { mapActions } from 'vuex'

const acsp = new AppCardServiceProxy()
const tssp = new TenantSettingServiceProxy()

export default {
  components: {
    DoughnutPie,
    UnfinishedPlanTable,
    UtilizationChart,
    DeviceStatusTable,
    DeviceAlarmTable,
    EmployeePerformanceTable,
    WorkRecord,
    PendingWork,
    RegionalCompletion,
    TotalRegions,
    ThresholdRateTable,
    ScreeningCustomersTable,
    GatewayStatueRecordCard,
    GatewayOverviewCard,
    MapView,
    DisabledCard,
    RepeatCustomDevice,
    InactiveDevice
  },
  data() {
    return {
      loading: false,
      test: 'doughnut-pie',
      selectCard: null,
      isMove: false,
      unit: 0,
      getPosition: getPosition,
      drag: null,
      type: 'create',
      onDrag: false,
      plStyle: {
        display: 'none'
      },
      items: [],
      cards: []
    }
  },
  computed: {
    registeredComps() {
      return Object.keys(this.$options.components).map((item) => item.toLowerCase())
    },
    getCursor() {
      if (this.type === 'create') return { cursor: 'default' }
      if (!this.onDrag)
        return {
          cursor: 'pointer'
        }
      return { cursor: this.drag.canDrop ? 'pointer' : 'no-drop' }
    }
  },
  async mounted() {
    this.initImc()
    this.loading = true
    this.drag = new Drag()

    const cards = await acsp.list()
    this.cards = cards
    await this.getItems()
    this.getUnit()
    this.$nextTick(() => (this.loading = false))
  },
  beforeCreate() {
    window.onresize = () => {
      this.getUnit()
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    ...mapActions({
      saveMaterialPoint: 'app/saveMaterialPoint'
    }),
    showComponent(item) {
      let key = ''
      if (item.status !== 0 && this.registeredComps.includes(item.componentKey.replace(/-/g, ''))) {
        key = item.componentKey
      } else {
        key = 'disabled-card'
      }
      return key
    },
    initImc() {
      let script = document.getElementById('imc-isv')

      if (!script) {
        script = document.createElement('script')
        script.id = 'imc-isv'
        script.src = 'https://imc-file.obs.cn-north-4.myhuaweicloud.com/imc/noAuth/js/isv.js'
        document.body.append(script)
      }
    },
    async getItems() {
      const items = await tssp.cardDetail()
      this.items = items
    },
    // 删除卡片
    deleteItem(item) {
      const newData = [...this.items]
      this.items = newData.filter((res) => res.id != item.id)
    },
    // 修改卡片名称
    saveNameEdit(value, item) {
      const newData = [...this.items]
      const target = newData.find((res) => res.id === item.id)
      if (target) {
        target.cardName = value
        this.items = newData
      }
    },
    // 保存卡片编辑
    async saveEdit() {
      await tssp.saveCardSetting({ tenantCardSetting: this.items })
      this.$message.success(this.$t('save_success'))
      this.type = 'create'
    },
    getUnit() {
      const unit = this.$refs.container.getBoundingClientRect().width / 12
      this.unit = unit
    },
    openEdit() {
      this.type = 'edit'
    },
    cancelEdit() {
      this.getItems()
      this.type = 'create'
    },
    startDrag(card, isMove) {
      const config = configs[card.componentKey]
      this.isMove = isMove
      this.selectCard = card
      this.onDrag = true
      const rect = this.$refs.container.getBoundingClientRect()
      this.drag.register(
        {
          ...card,
          ...config
        },
        rect,
        this.items,
        isMove ? card : null
      )
    },
    endDrag() {
      if (!this.onDrag) return
      this.onDrag = false
      const cb = (value) => {
        if (this.isMove) {
          this.selectCard.cardLocal = JSON.stringify(value)
        } else {
          const data = {
            cardLocal: JSON.stringify(value),
            cardName: this.selectCard.displayName,
            cardValue: '',
            componentKey: this.selectCard.componentKey,
            id: this.selectCard.id
          }
          this.items.push(data)
        }
      }
      this.drag.onDrop(cb)
    },
    hidePlaceHolder() {
      this.drag.unRegister(this.setStyle.bind(this))
    },
    overContainer(e) {
      e.preventDefault()
      const cb = (style) => {
        this.plStyle = style
      }
      this.drag.onMove(e, this.setStyle.bind(this))
    },
    setStyle(style) {
      this.plStyle = style
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  height: 100%;
}
.header {
  // height: 24px;
}
.container-wrapper {
  box-sizing: border-box;
  width: 100%;
  overflow-y: auto;
  // border: 1px solid red;
  margin-top: 10px;
  margin-bottom: 10px;

  .container {
    height: 10000px;
    position: relative;
  }
}

.item-card-wrapper {
  box-sizing: border-box;
  position: absolute;
  // background: blue;
  padding: 8px;

  .item-card-content {
    width: 100%;
    height: 100%;
    background: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    border-top: 0;
  }
}

.item-card-header,
.placeholder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
}

.placeholder {
  box-sizing: border-box;
  position: absolute;
  padding: 8px;
  > div {
    border-radius: 3px;
    border: 1px dashed #999;
    background: #eee;
    width: 100%;
    height: 100%;
  }
}

.footer {
  .footer-buttons {
    height: 40px;
  }
}

.cards {
  width: 100%;
  overflow-x: auto;
  display: flex;
  background: #fff;
  border: 1px solid #eee;
  padding: 10px;
  box-sizing: border-box;

  .card {
    cursor: pointer;
    text-align: center;
    img {
      display: block;
      width: 320px;
      height: 160px;
      border: 1px solid #eee;
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }
}
.comp {
  display: block;
  margin: 0 auto;
  height: calc(100% - 50px) !important;
  // width: calc(100% - 50px) !important;
}
/deep/ .ant-tabs-bar {
  margin: 0;
  margin-bottom: -1px;
}
.item-card-tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;
  padding: 0;
  border-bottom: 1px solid #eee;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  i {
    cursor: pointer;
  }
}
::-webkit-scrollbar {
  width: 0;
}
</style>
